import { getTranslateByKey } from "@/main/services/utils";
import React from "react";
import KogBoxGridParameter, { IOptionGridMultiline } from "../../../../boxGridMultiline/boxGridParameter";
import * as StylesShared from "../../../../styles";
import { ParameterTypesResponse } from "@/main/models/response/parameterTypesResponse";
import { handleValueParameterType } from "../utils";

interface ISectionParameterProps {
	dataParameterAPI: ParameterTypesResponse[];
	dataParametersScreen: ParameterTypesResponse[];
	setDataParametersScreen: React.Dispatch<React.SetStateAction<ParameterTypesResponse[]>>;
}
function SectionParameter({ dataParameterAPI, dataParametersScreen, setDataParametersScreen }: ISectionParameterProps) {
	const rowHeaders = [
		getTranslateByKey("information.registerInsurerParametersParameter"),
		getTranslateByKey("information.description"),
		<StylesShared.RowHeaderTextCenter key="2">
			{getTranslateByKey("information.value")}
		</StylesShared.RowHeaderTextCenter>,
	];
	function handleValue(idParameterTypeRow: number, id: string, newValue: string | null) {
		const newDataParameters = handleValueParameterType(idParameterTypeRow, id, newValue, dataParametersScreen);
		setDataParametersScreen(newDataParameters);
	}

	const optionsGrid: IOptionGridMultiline[] = dataParametersScreen.map((data) => ({
		id: data.idParameterType,
		elements: [
			{
				typeColumn: "parameterName",
				content: data.name,
				width: "40%",
			},
			{
				typeColumn: "description",
				content: data.parameters.map((parameter) => parameter.description),
				width: "40%",
			},
			{
				typeColumn: "value",
				content: data,
				valueParameterAPI: dataParameterAPI.find((parameter) => parameter.idParameterType === data.idParameterType),
				width: "10%",
			},
		],
	}));
	if (dataParametersScreen.length === 0) return null;

	return <KogBoxGridParameter rowHeaders={rowHeaders} options={optionsGrid} handleValue={handleValue} />;
}

export default SectionParameter;
